import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";

//
import OneSignal from "react-onesignal";

//
import useCheckPlan from "../hooks/useCheckPlan";

//
import { getCoins, getConfigs } from "../redux/features/coins/actions";
import {
  getUser,
  getNotifications,
  sendPlayerID,
} from "../redux/features/user/actions";
import { getSubscriptions } from "../redux/features/plan/actions";
import { setWindowSize } from "../redux/features/theme/slice";
//
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import SubscriptionAlarm from "../components/general/SubscriptionAlarm";
import BoxLoading from "../components/general/BoxLoading";
import PlanModal from "../components/account/plan/PlanModal";
// import ProductModal from "../components/account/plan/ProductModal";
import ConnectTelegramModal from "../components/account/profile/ConnectTelegramModal";
import TelegramConnectAlert from "../components/general/TelegramConnectAlert";
import NoUserAlarm from "../components/general/NoUserAlarm";

function Main({
  user,
  getCoins,
  getConfigs,
  getUser,
  getNotifications,
  setWindowSize,
  showFooter,
}) {
  const needLoginPages = ["account", "portfolio", "ticket"];
  const token = localStorage.getItem("token");
  let location = useLocation();

  const [sidebar, setSidebar] = useState(false);
  const [loading, setLoading] = useState(true);

  const [checkPlan, checkTelegram] = useCheckPlan();

  const userCanSeeRoute = () => {
    const path = location.pathname;
    let canSee = true;
    if (token) {
      return true;
    } else {
      for (let i = 0; i < needLoginPages.length; i++) {
        const page = needLoginPages[i];
        if (path.includes(page)) {
          canSee = false;
          break;
        }
      }

      return canSee;
    }
  };

  const callOneSignalFunctions = async () => {
    if (user.email) {
      await OneSignal.setEmail(user.email);

      const id = await OneSignal.getUserId();

      if (id) {
        sendPlayerID({ id });
      }
    }
  };

  useEffect(async () => {
    setLoading(true);
    await getCoins();
    if (token) {
      await getUser();
      await getConfigs();
      await getNotifications({ page: 1, perPage: 5000 });
      setLoading(false);
      await OneSignal.init({ appId: process.env.REACT_APP_ONESIGNAL_APP_ID });
      await callOneSignalFunctions();
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setWindowSize(window.innerWidth);
    const handleResizeWindow = () => setWindowSize(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
  }, []);

  return userCanSeeRoute() ? (
    <div className="d-flex">
      <Sidebar
        sidebarActive={sidebar}
        setSidebar={() => setSidebar(!sidebar)}
      />

      <div
        className={`main-content ${!token ? "no-navbar" : ""} ${
          !token ? "with-alert" : ""
        }`}
      >
        <Navbar setSidebar={() => setSidebar(!sidebar)} />

        {loading ? (
          <BoxLoading />
        ) : (
          <>
            {!token && <NoUserAlarm />}

            {/* {!checkPlan() && <SubscriptionAlarm />}

            {!checkTelegram() && <TelegramConnectAlert />} */}

            <div className="page-holder">
              <Outlet />
              <footer className={`page-footer ${!showFooter ? "d-none" : ""}`}>
                <small className="text-muted fw-bold">
                  Copyright © 2021 Invalert
                </small>
              </footer>
            </div>
          </>
        )}
      </div>

      <PlanModal />
      {/* <ProductModal /> */}

      <ConnectTelegramModal />
    </div>
  ) : (
    <Navigate to="/auth" replace />
  );
}

Main.propTypes = {
  user: PropTypes.object.isRequired,
  getCoins: PropTypes.func.isRequired,
  getConfigs: PropTypes.func.isRequired,
  showFooter: PropTypes.bool.isRequired,
  getUser: PropTypes.func.isRequired,
  setWindowSize: PropTypes.func.isRequired,
  getNotifications: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  getCoins,
  getConfigs,
  getUser,
  setWindowSize,
  getNotifications,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
  showFooter: state.themeReducer.showFooter,
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
